import { Alert, AlertTitle, Slide, useMediaQuery } from "@mui/material";
import {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState,
} from "react";

import { IAlertContextData, IAlertData } from "alert-context";

import { useAppThemeContext } from "./ThemeContext";

interface IFuncComponentsProps {
  children: React.ReactNode;
}

const _defaultTimeout = 1000;

const AlertContext = createContext({} as IAlertContextData);

export const useAppAlertContext = () => useContext(AlertContext);

export const AlertContextProvider: React.FC<IFuncComponentsProps> = ({
  children,
}) => {
  const { theme } = useAppThemeContext();
  const [show, setShow] = useState(false);
  const [alert, setAlert] = useState<IAlertData>();
  const smDown = useMediaQuery(theme.breakpoints.down("sm"));

  const showAlert = useCallback(
    (alert: IAlertData, interval?: number) => {
      setAlert(alert);
      setShow(true);

      setTimeout(() => setShow(false), interval || _defaultTimeout);
    },
    [setShow]
  );

  const isShowing = useMemo(() => show, [show]);

  return (
    <AlertContext.Provider value={{ isShowing, showAlert }}>
      <>
        <Slide direction="left" in={show}>
          <Alert
            sx={{
              position: "fixed",
              width: smDown ? "50vw" : "20vw",
              top: theme.spacing(10),
              right: "0",
            }}
            variant="filled"
            severity={alert?.severity}
          >
            <AlertTitle>
              {alert?.title ? alert?.title : alert?.severity.toUpperCase()}
            </AlertTitle>
            {alert?.message}
          </Alert>
        </Slide>

        {children}
      </>
    </AlertContext.Provider>
  );
};
